import { images } from "../constants";

const testimonials = [  
  { 
    id: 1,
    image: images.testimonial1, 
    name: 'Michael Anderson', 
    title: 'Homeowner',
    content: 'BuildPro transformed our dream home into reality. Their team was highly professional, and the craftsmanship was top-notch. Highly recommended for any residential project!'
  }, 
  { 
    id: 2,
    image: images.testimonial2, 
    name: 'Jessica White', 
    title: 'Business Owner',
    content: 'The BuildPro team constructed our new office space with perfection. Their attention to detail and commitment to quality exceeded our expectations. Great work!'
  },
  { 
    id: 3,
    image: images.testimonial3, 
    name: 'David Martinez', 
    title: 'Developer',
    content: 'BuildPro managed the construction of our apartment complex flawlessly. Their project management skills ensured timely delivery without compromising on quality.'
  },    
  { 
    id: 4,
    image: images.testimonial4, 
    name: 'Emily Roberts', 
    title: 'Architect',
    content: 'As an architect, I appreciate BuildPro\'s dedication to precision and aesthetics. They brought my designs to life with perfection and efficiency for construction services.'
  },
];

export default testimonials;